export namespace InboxEmail {
  export enum ViewMode {
    ByDate = 1,
    ByUser = 2,
    ByStatus = 3,
  }

  export enum ViewFilterByStatus {
    Pending = 1,
    Relevant = 2,
    NonRelevant = 3,
  }
}
